import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Input } from '@angular/core';
import { NavController } from '@ionic/angular';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

@Component({
  selector: 'bus-recent-search',
  templateUrl: './bus-recent-search.component.html',
  styleUrls: ['./bus-recent-search.component.scss'],
})
export class BusRecentSearchComponent implements OnInit {
  @Input() recentSearches: any[];
  @Output() recentSearchSelected = new EventEmitter<any>();
  ngOnInit(): void {}
  constructor(private analyticsService: AnalyticsService) {}

  onCardClick(item: any) {
    this.recentSearchSelected.emit(item);
    this.analyticsService.trackUnified('recent_search_selected', {
      flow: 'bus',
      outcome: 'success',
      legacy_event_name: 'Bus Recent Search Selected',
      source: item.source,
      destination: item.destination,
      source_entity_id: item.sourceEntityId,
      destination_entity_id: item.destinationEntityId,
      departure_date: item.departureDate,
    });
  }
}
